import { render, staticRenderFns } from "./ModalConfirmSendEvent.vue?vue&type=template&id=9fdb3f90"
import script from "./ModalConfirmSendEvent.vue?vue&type=script&lang=js"
export * from "./ModalConfirmSendEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports